// src/components/Navbar.js
import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Phone, Menu, X, Calculator } from "lucide-react";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  /* Stäng mobilmenyn automatiskt vid sidbyte */
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  /* Huvudlänkar */
  const links = [
    { to: "/", label: "Hem" },
    { to: "/tjanster", label: "Tjänster" },
    { to: "/om-oss", label: "Om oss" },
  ];

  return (
    <header className="sticky top-0 z-50 bg-white/90 backdrop-blur shadow-sm">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        {/* LOGO */}
        <Link
          to="/"
          className="text-2xl font-extrabold tracking-tight text-blue-600"
          aria-label="Rent & Klart – hem"
        >
          Rent&nbsp;&amp;&nbsp;Klart
        </Link>

        {/* DESKTOP NAV */}
        <nav className="hidden md:flex items-center gap-6">
          {links.map(({ to, label }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                `font-medium transition-colors ${
                  isActive ? "text-blue-600" : "text-gray-700 hover:text-blue-600"
                }`
              }
            >
              {label}
            </NavLink>
          ))}

          {/* Räkna pris – scroll till kalkylatorn */}
          <a
            href="/#calc"
            className="flex items-center gap-1 bg-blue-50 border border-blue-600 text-blue-600 px-4 py-2 rounded-full font-semibold hover:bg-blue-100 transition"
          >
            <Calculator className="w-4 h-4" />
            Räkna&nbsp;pris
          </a>

          {/* Telefon-knapp */}
          <a
            href="tel:+46734877119"
            className="flex items-center gap-1 bg-blue-600 text-white px-4 py-2 rounded-full font-semibold hover:bg-blue-700 transition"
          >
            <Phone className="w-4 h-4" />
            073&nbsp;487&nbsp;71&nbsp;19
          </a>
        </nav>

        {/* MOBILE TOGGLE */}
        <button
          className="md:hidden text-gray-700 focus:outline-none"
          aria-label="Öppna meny"
          onClick={() => setOpen(!open)}
        >
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* MOBILE MENU */}
      {open && (
        <div className="md:hidden bg-white border-t border-gray-200 shadow-sm">
          <nav className="flex flex-col gap-3 px-4 py-6">
            {links.map(({ to, label }) => (
              <NavLink
                key={to}
                to={to}
                className="text-gray-700 hover:text-blue-600 font-medium"
              >
                {label}
              </NavLink>
            ))}

            <a
              href="/#calc"
              className="flex items-center gap-2 text-gray-700 hover:text-blue-600 font-medium"
            >
              <Calculator className="w-4 h-4" />
              Räkna pris
            </a>

            <a
              href="tel:+46734877119"
              className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-full font-semibold hover:bg-blue-700 transition"
            >
              <Phone className="w-4 h-4" />
              073&nbsp;487&nbsp;71&nbsp;19
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
